import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowClockwiseUpRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M460 0Q321 0 217 62 113 124 56.5 239 0 354 0 509 0 672 62.5 782.5 125 893 231.5 946.5 338 1000 470 1000 639 1000 743 931 847 862 924 742L858 701Q796 809 706 867.5 616 926 470 926 369 926 279.5 882 190 838 136 757.5 82 677 82 573L82 441Q82 340 131.5 256 181 172 266.5 123 352 74 456 74 619 74 712 161 805 248 847 370L586 370 586 448 980 448 980 60 902 60 902 214 904 319Q879 245 822 172.5 765 100 673 50 581 0 460 0Z" })
});
export default SvgArrowClockwiseUpRight;
